import React from 'react';
import CookieConsent from 'gatsby-core-theme/src/components/organisms/cookie-consent';

export default (props) => (
  <CookieConsent 
    {...props} 
    showRejectButton 
    settingsCookie={false} 
    rejectText='Reject Non-necessary' 
    acceptText='Accept All Cookies' 
  >
    Please note that on our website we use cookes necessary for the functioning of our website, cookes that optimize the performance. To learn more about our cookies  please read our <a href='/cookies'>Cookie Policy</a>
  </CookieConsent>
)